import { Phone } from 'lucide-react'
import React from 'react'


export default function Privacy() {
    return (
        <div className='w-full px-5 md:w-[80%] h-auto m-auto  mt-10 md:px-10 mb-10'>

            <h1 className=' font-bold text-3xl'>PRIVACY POLICY</h1>
            <div className='w-full  space-y-5 font-sans    '>
                <p className='mt-5 font-semibold text-gray-800'>Last updated: August 13, 2021</p>
                <p className=''> This Privacy Policy describes our policies and procedures on the collection, use, and disclosure of your
                    information when you use our services and explains your privacy rights and how the law protects you.</p>
                <p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the Privacy Policy Generator.</p>
                <h1 className='text-gray-900 text-2xl font-bold'> Interpretation and Definitions</h1>
                <h1 className='font-bold text-xl '>Interpretation</h1>

                <p>The words with capitalized initial letters have defined meanings under the conditions outlined below. These definitions apply regardless of whether they appear in singular or plural.
                </p>
                {/* {Definitions } */}



                <h1 className='font-bold text-xl '>Definitions</h1>
                <p>For the purposes of this Privacy Policy:</p>
                {/* {list } */}

                <div className=' space-y-3 px-5 '>
                    {definitiondata.map((items, index) => (

                        <li key={index} className='text-gray-800 font-bold  '>{items.name} <span className='font-normal '>{items.description}</span></li>


                    ))}
                </div>


            </div>
            <div className='space-y-5 text-lg font-sans text-gray-800 font-semibold mt-10'>
                {/* {Collecting and Using Your Personal Data} */}

                <h1 className='text-gray-900  text-2xl font-bold'>Collecting and Using Your Personal Data</h1>
                <h1 className='font-bold text-xl '>Types of Data Collected</h1>
                <p className='font-bold text-lg '>Personal Data</p>
                <p className='font-normal '> We may collect personal data, including but not limited to:</p>
                <div className='px-5 space-y-3 font-normal  '>
                    <li>Full name</li>

                    <li> Contact details (email, phone number, address)</li>

                    <li>Resume/CV and employment history </li>

                    <li>Skills, certifications, and educational qualifications </li>

                    <li>LinkedIn or social profile URLs</li>
                    <li>Interview feedback, background checks, and other employment-related information</li>
                </div>


                <div className='space-y-5 mt-5 text-lg'>
                    <h1 className='text-gray-900  text-2xl font-bold'>Usage Data</h1>
                    <h1 className='font-normal text-lg'>We collect information such as:</h1>
                    <div className='px-5 space-y-3 font-normal text-lg'>
                        <li>IP address, browser type, operating system</li>
                        <li> Pages visited on our website and duration of visit</li>
                        <li>Device identifiers and referral URLs</li>

                    </div>

                </div>

                <div className='space-y-5 mt-5 text-lg'>
                    <h1 className='text-gray-900  text-2xl font-bold'> Information from Third-Party Sources</h1>
                    <h1 className='font-normal text-lg'> We may receive personal data about you from other sources including:</h1>
                    <div className='px-5 space-y-3 font-normal text-lg'>
                        <li> Job boards and professional networking sites</li>
                        <li> Referrals and recommendations</li>
                        <li>Background screening services</li>
                        <li>
                            Social media services if you apply or connect via LinkedIn, Google, or Facebook
                        </li>

                    </div>
                    <div className='space-y-5 mt-5 text-lg'>
                        <h1 className='text-gray-900  text-2xl font-bold'>    Use of Your Personal Data</h1>
                        <h1 className='font-normal text-lg'>We use your data for purposes including:</h1>
                        <div className='px-5 space-y-3 font-normal text-lg'>
                            <li>  To provide recruitment and staffing services</li>
                            <li>To assess your qualifications and match you with potential roles</li>
                            <li>To communicate regarding job opportunities, interviews, or assignments</li>
                            <li>To manage accounts, timesheets, and payroll for contractors</li>
                            <li>To fulfill contractual obligations with clients and candidates</li>
                            <li>For business analytics and process improvements</li>

                            <li>To notify you of updates, events, or job market trends (unless you opt out)</li></div>

                    </div>

                    <div className='space-y-5 mt-5 text-lg'>
                        <h1 className='text-gray-900  text-2xl font-bold'>  Sharing Your Personal Data</h1>
                        <h1 className='font-normal text-lg'>We may share your information with:</h1>
                        <div className='px-5 space-y-3 font-normal text-lg'>
                            <li>  Clients for whom you may be considered for a job</li>
                            <li>  Background screening providers, if required</li>

                            <li>Technology and service providers supporting our platform and processes
                            </li>
                            <li> Business partners or affiliates, for joint service delivery</li>
                            <li>Government authorities, when required by law or regulation</li>
                            <li>In business transfers, such as a merger, acquisition, or sale of company assets</li>

                        </div>
                    </div>

                    <div className='space-y-5 mt-5 text-lg'>
                        <h1 className='text-gray-900  text-2xl font-bold'>Retention of Your Data</h1>
                        <h1 className='font-normal text-lg'>We retain your data as long as necessary to:
                        </h1>
                        <div className='font-normal text-lg space-y-3 px-5'>
                            <li>Provide services to you or our clients</li>
                            <li> Comply with legal and regulatory obligations</li>
                            <li>    Maintain business and compliance records</li>

                            <li>  You may request data deletion subject to legal limitations.</li>
                        </div>
                        {retentiondata.map((items, index) => (
                            <div key={index} className=' gap-1  '>
                                <ul>
                                    <li className='text-gray-800 font-bold text-lg '>{items.title} </li>
                                </ul>
                                <span className='font-normal text-lg'>{items.description}</span>
                            </div>
                        ))}
                    </div>


                    <div className='space-y-5 mt-5 text-lg'>
                        <h1>Contact us </h1>
                        <h1 className='font-normal text-lg'>If you have questions about this Privacy Policy, you can contact us: </h1>
                        <h1>📧 Email:
                            <a
                                href="mailto:Application@rtventure.net"
                                className="hover:text-gray-400 transition-colors duration-300 font-normal text-lg"
                            >  Application@rtventure.net
                            </a></h1>
                        <h1 className='flex flex-wrap  items-center sm:gap-2'><Phone />  Phone number: <a
                            href="tel:+9779709742080"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block  hover:text-gray-400 transition-colors duration-300 font-normal text-lg"
                            title="Chat on WhatsApp"
                        >+977-9709742080
                        </a></h1>
                        <div className="flex flex-wrap items-center justify-center gap-2 mt-5 px-5 text-center text-sm text-gray-600">
                            <h1 className="whitespace-nowrap">
                                © {new Date().getFullYear()}.
                            </h1>
                            <p className="whitespace-nowrap">All rights reserved.</p>
                            <a
                                href="https://rtventure.net/"
                                className="whitespace-nowrap hover:text-blue-600 transition-colors duration-200"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                RamdhuniTech Venture
                            </a>
                        </div>

                    </div>












                </div>

            </div>
        </div >)
}


export const definitiondata = [
    {
        name: 'Account',
        description: ' means a unique account created for you to access our services or parts of our services.'
    },

    {
        name: 'Affiliate',
        description: '  means an entity that controls, is controlled by, or is under common control with us.'
    },
    {
        name: 'Company',
        description: '  (referred to as "the Company", "We", "Us" or "Our") refers to [Your Staffing Company Name].'
    },
    {
        name: 'Device',
        description: ' Device means any device used to access our services such as a computer or smartphone.'
    },
    {
        name: 'Personal Data',
        description: ' is information that relates to an identified or identifiable individual.'
    },
    {
        name: 'Service',
        description: '  refers to our staffing, recruiting, consulting, and technology solutions.'
    },
    {
        name: 'Service Provider',
        description: '  means third-party vendors, consultants, or partners engaged by the Company.'
    },
    {
        name: 'Usage Data',
        description: ' refers to information collected automatically, including through usage of the website or platform.'
    },
    {
        name: 'You',
        description: 'refers to the individual or organization accessing or using the Service, including job seekers, clients, and contractors.        '
    },

]



export const retentiondata = [
    {
        title: 'Transfer of Your Personal Data',
        description: 'Your data may be processed outside your country of residence, in countries with different data protection laws. We take appropriate measures to ensure secure and lawful processing.'
    },
    {
        title: 'Security of Your Data',
        description: 'We use appropriate technical and organizational measures to secure your personal information.However, no method of transmission over the internet is 100 % secure.'
    },
    {
        title: " Children's Privacy",
        description: 'Our services are not intended for individuals under the age of 18. We do not knowingly collect personal data from children.If we become aware that we have collected such data, we will delete it.'
    },
    {
        title: 'Links to Other Websites',
        description: 'Our platform may contain links to third - party websites.We are not responsible for their privacy practices.'
    },
    {
        title: 'Changes to This Policy',
        description: 'We may update this Privacy Policy periodically.You will be notified through email or a prominent notice on our website when updates occur.Review this policy regularly.'
    },

]
















